'use strict';

module.exports = function(Chart) {

	Chart.Doughnut = function(context, config) {
		config.type = 'doughnut';

		return new Chart(context, config);
	};

};



//////////////////
// WEBPACK FOOTER
// ./~/angular-chart.js/~/chart.js/src/charts/Chart.Doughnut.js
// module id = 204
// module chunks = 0